import styled from 'styled-components'
import { styled as muiStyled } from '@mui/system'
import { ButtonBase } from '@mui/material'

export const HomePageContainer = styled.div`
  width: 100%;
  padding: 30px 10px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  @media (min-width: 768px) {
    padding: 70px 20px;
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
  }
`

export const HomePageItem = muiStyled(ButtonBase, {
  shouldForwardProp: (prop) => prop !== 'otherColor',
})`
    width: 100%;
    height: 156px;
    flex-shrink: 0;
    border-radius: 10px;
    background: ${(props) =>
      props?.otherColor
        ? props?.otherColor
        : 'linear-gradient(46deg, #F55 0%, #000 0.01%, #9747FF 100%)'};
    box-shadow: 7px 7px 14px 0px rgba(0, 0, 0, 0.25);
    cursor: pointer;
    color: #FFF;
    font-family: Outfit;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    @media (min-width: 768px) {
      width: 202px;
      font-size: 20px;
    }
`
export const HomePageAlertsContainer = muiStyled('div')(
  ({ theme }) => `
      width: 100%;
      padding: 0px 20px;
      @media (min-width:768px){
        padding: 0px 20px;
      }
`,
)

export const HomePageAlert = muiStyled(ButtonBase)(
  ({ theme }) => `
  padding: 10px 0px;
  width: 100%;
  justify-content: flex-start;
`,
)
